import L from "leaflet";
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

export default {
  computed: {
    paramsList() {
      return this.parametersList.map((i) => {
        return {
          id: i.id,
          name: i.name
        }
      })
    },
  },
  mounted() {
    this.initMap(this.mapCenter);
  },
  methods: {
    initMap(mapCenterData) {
      if (this.map) {
        this.map.remove();
      }
      const {center, zoom} = mapCenterData;
      this.map = L.map(this.$refs.map).setView(center, zoom);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
      if (Object.keys(this.markerCoords).length) {
        const icon = L.icon({
          iconUrl: markerIcon,
          shadowUrl: iconShadow,
        });
        const marker = L.marker([this.markerCoords.lat, this.markerCoords.long], {
          icon: icon,
        });
        marker.addTo(this.map);
      }
      const zoomToggle = this.$refs.map.querySelector('.leaflet-top');
      zoomToggle.style.zIndex = "998";
    },
    setCoords(coords) {
      if (coords) {
        this.markerCoords.lat = Number(coords[1]);
        this.markerCoords.long = Number(coords[0]);
        this.field.coords = `${this.markerCoords.lat}, ${this.markerCoords.long}`;
        const mapCenterData = {
          center: [this.markerCoords.lat, this.markerCoords.long],
          zoom: 10,
        };
        this.initMap(mapCenterData);
        this.$e.successBox('Размещение выполнено успешно')
      } else {
        this.markerCoords = {};
        this.initMap(this.mapCenter);
        this.field.coords = "";
        this.$e.errorBox('Координаты отсутствуют! Повторите попытку');
      }
    },
  }
}
